import { useState, useEffect } from "react";

import { socialIcons } from "./social_icons";

import Image from "next/image";
import Link from "next/link";

import fetchHeaderFooterData from "@/hooks/fetchHeaderFooterData";
import { MEDIA_BASE_URL } from "@/utils/api";

import axios from "axios";
import dynamic from "next/dynamic";
import Footer_Logo_Description from "./footer_logo_description";
import Footer_Second_Section from "./footer_second_section";
// import NewsLetterSec from "./newsletter_sec";
// import FooterLogo from "./footerLogo";
// import Open_Close_Footer from "./open_close_footer";
// import Footer_Bottom from "./footer_bottom";

const NewsLetterSec = dynamic(() => import('./newsletter_sec'), {
  ssr: false,
});

const FooterLogo = dynamic(() => import('./footerLogo'), {
  ssr: false,
});

const Open_Close_Footer = dynamic(() => import('./open_close_footer'), {
  ssr: false,
});

const Footer_Bottom = dynamic(() => import('./footer_bottom'), {
  ssr: false,
});


const Footer = () => {
  const mediaBaseUrl = MEDIA_BASE_URL;

  // get footer api data
  const { footerApiData } = fetchHeaderFooterData();
  // const footerFirstSection = footerApiData.section_1
  //   ? footerApiData.section_1.content
  //   : {};

  const footerFirstSection = footerApiData?.section_1?.content || {};

  const footerFirstSectionIcons =
    footerApiData?.section_1?.content?.icons || [];
  const footerSecondSection = footerApiData?.section_2
    ? footerApiData?.section_2?.content
    : {};
  const footerSecondMenu =
    footerSecondSection?.menu && footerSecondSection?.menu?.length > 0
      ? footerSecondSection?.menu
      : [];
  const footerThirdSection = footerApiData?.section_3
    ? footerApiData?.section_3?.content
    : {};
  const footerThirdMenu =
    footerThirdSection?.menu && footerThirdSection?.menu?.length > 0
      ? footerThirdSection.menu
      : [];
  const footerFourthSection = footerApiData?.section_4
    ? footerApiData?.section_4?.content
    : {};
  const footerFifthSection = footerApiData?.section_5
    ? footerApiData?.section_5?.content
    : {};
  const newsletterSection = footerApiData?.newsletter || {};

  // Local state management
  const [open, setOpen] = useState(true);
  const [ipAddress, setIpAddress] = useState("");
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);

  function handleClick() {
    setOpen(!open);
  }

  useEffect(() => {
    // Fetch IP address when component mounts
    axios
      .get("https://api.ipify.org?format=json")
      .then((response) => setIpAddress(response.data.ip))
      .catch((error) => console.error("Error fetching IP address:", error));
  }, []);

  // Function to validate email
  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  // Handle input change
  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setIsValidEmail(emailValue === "" || validateEmail(emailValue));
  };

  // Handle newsletter subscription
  const handleNewsletterSubscription = async () => {
    if (validateEmail(email)) {
      // API call or subscription logic
      try {
        const response = await fetch("/api/newsletter/handler", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            ipAddress,
          }),
        });
        if (response.ok) {
          const responseData = await response.json();
          const data = responseData.data;
          if (data) {
            alert(`${data?.title}\n${data?.text}`);
          }
        } else {
          console.error("Error response from server:", response.statusText);
          alert("Failed to subscribe. Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("An error occurred. Please try again later.");
      }
      setEmail(""); // Clear the input field after subscription
    } else {
      setIsValidEmail(false);
    }
  };







  return (
    <div>
    {footerFirstSection && <div className="text-[#DBDBDB]">
      {newsletterSection && <NewsLetterSec newsletterSection={newsletterSection} email={email} handleEmailChange={handleEmailChange} isValidEmail={isValidEmail} handleNewsletterSubscription={handleNewsletterSubscription} />}
      <div className="bg-light-black text-[#DBDBDB] pt-8 lg:pt-[4vw]">
        <div className="container lg:px-[4vw]">
          <div className="flex flex-wrap justify-between gap-y-10 lg:gap-0">
            <Footer_Logo_Description footerFirstSection={footerFirstSection} mediaBaseUrl={mediaBaseUrl} footerFirstSectionIcons={footerFirstSectionIcons} socialIcons={socialIcons} />

            <Footer_Second_Section footerSecondSection={footerSecondSection} footerSecondMenu={footerSecondMenu} footerThirdSection={footerThirdSection} footerThirdMenu={footerThirdMenu} footerFourthSection={footerFourthSection} />
          </div>
        </div>

        {footerFifthSection && <Open_Close_Footer open={open} handleClick={handleClick} footerFifthSection={footerFifthSection} />}
      </div>
      {
        footerFifthSection && <Footer_Bottom footerFifthSection={footerFifthSection} />
      }
    </div>}
    </div>
  );
};

export default Footer;
